import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from './messages/message.service';
import { Observable, map, take } from 'rxjs';
import { FeedbackQuestionnaire } from '../models/feedback-questionnaire';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as messageBoxComponent from 'app/components/messageBox/messageBox.component';
import { UserQuestionnairePrompts } from '../models/user-questionnaire-prompts';
import { environment } from 'environments/environment';

// tslint:disable-next-line:max-classes-per-file
export class FeedbackInfo {
    feedback: string;
}

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

// tslint:disable-next-line:max-classes-per-file
@Injectable({ providedIn: 'root' })
export class FeedbackService implements OnInit, OnDestroy {    
    changed: BehaviorSubject<any> = new BehaviorSubject([]);
    websiteUrl = 'https://intecfeedback.intecdev.co.uk:5002/#/questionnaire-response/';
    data: FeedbackQuestionnaire[] = [];
    feedbackMessage = `Would you like to leave us some feedback? This will help us make the improvements you need. Please click Yes to complete a short questionnaire.`;
    resourceUrl = 'api/feedback';
    amountOfQuestionnaires: number;

    constructor(private dialog: MatDialog, public http: HttpClient, public messageService: MessageService, protected router: Router) {        
        // Get correct INTEC Feedback website URL depending on environment (Live, Test or Dev) - PJT
        if (environment.production === true) {
            if (window.location.href.toLocaleLowerCase().indexOf("incase365.") > -1)
                this.websiteUrl = 'https://intecfeedbacklive.azurewebsites.net/#/questionnaire-response/';
            else
                this.websiteUrl = 'https://intecfeedbacktest.azurewebsites.net/#/questionnaire-response/';
        }
        else
            this.websiteUrl = 'https://intecfeedback.intecdev.co.uk:5202/#/questionnaire-response/';
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    getQuestionnaires(): Observable<FeedbackQuestionnaire[]> {
        return this.http.get<FeedbackQuestionnaire[]>(this.resourceUrl + '/getQuestionnaires', httpOptions).pipe(map((response: FeedbackQuestionnaire[]) => {            
            this.data = [...response];
            this.amountOfQuestionnaires = this.data.length;
            this.changed.next(response);
            return this.data;
        }));
    }
    
    promptForFeedback(questionnaireId:number, url:string, title:string)
    {
        this.dialog.open(messageBoxComponent.MessageBoxComponent, {
            data: new messageBoxComponent.MessageBoxParameters(
                this.feedbackMessage,
                'Would you like to leave feedback on InCase365 on the subject of "' + title + '" ?',
                messageBoxComponent.MessageBoxType.YesNo,
                false
            ),
        }).afterClosed().subscribe((r) => {
            if (r === 'yes') {
                this.postFeedbackResponse(questionnaireId, "yes");            
                window.open(url, '_blank');
            }
            if (r === 'no') {
                //store this response still.                        
                this.postFeedbackResponse(questionnaireId, "no");
                this.dialog.closeAll();
            }   
        })
    }

    postFeedbackResponse(questionnaireId:number, response: string) {
        return this.http.post<UserQuestionnairePrompts>(this.resourceUrl + '/' + response + '/' + questionnaireId, httpOptions).pipe(take(1)).subscribe((r: any) => {
            this.messageService.success('Your response has been noted. Thank you!', 'Response Accepted');
        })
    }   
    
    public postFeedback(feedback: string) {
        const entity = new FeedbackInfo();
        entity.feedback = feedback;

        return this.http.post<FeedbackInfo>(this.resourceUrl, entity, httpOptions).pipe(take(1)).subscribe((response: any) => {
            if (response && response.status === 200) {
                console.log('feedback sent ok');
                this.messageService.success('Your feedback was successfully sent', 'Feedback');
            }
            else {
                console.log('Failed to send feedback ' + response);
                this.messageService.error('Your feedback was not sent because of an error', 'Feedback');
            }
        });
    }
}


